/** @typedef PaletteConfig
 *  @extends PaletteState
 *  @property {boolean} visible - Indicates whether the palette is visible or not.
 */

/**
 * Generates a configuration object for the palette.
 * @param {PaletteState} palette - The current palette configuration.
 * @param {WorkflowMode} mode - The current mode of the application (e.g., 'edit' or 'view').
 * @param {Array} nodes - The palette nodes to display.
 * @returns {PaletteConfig} The updated palette configuration with visibility set based on the mode.
 */
export const getPaletteConfig = (palette, mode, nodes = []) => ({
  ...palette,
  visible: mode === 'edit' || mode === 'paused',
  nodes
})
